import PropTypes from "prop-types";
import {
  Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle,
} from "@/components/ui/dialog";
import { HelpCircle } from "lucide-react";
import { QuoraConnectForm, useQuoraConfigure } from "@/components/connections/QuoraConnectPanel";

export function QuoraConfigureDialog({
  open,
  onOpenChange,
  connectionId,
  ensureConnection,
  canEdit,
  onConfigured,
}) {
  const quora = useQuoraConfigure({
    connectionId,
    ensureConnection,
    canEdit,
    onConfigured: async (r) => {
      await onConfigured?.(r);
      onOpenChange(false);
    },
  });

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[520px]" data-testid="quora-configure-dialog" preventOutsideDismiss>
        <DialogHeader>
          <DialogTitle className="inline-flex items-center gap-2">
            <span className="inline-flex h-7 w-7 items-center justify-center rounded-md bg-red-100">
              <HelpCircle size={15} className="text-red-700" />
            </span>{" "}
            Connect Quora
          </DialogTitle>
          <DialogDescription className="text-[12px]">
            Link your Quora profile so Maya can monitor topics and draft answers in your voice.
          </DialogDescription>
        </DialogHeader>
        {open && (
          <QuoraConnectForm quora={quora} canEdit={canEdit} testIdPrefix="settings-quora" />
        )}
      </DialogContent>
    </Dialog>
  );
}

QuoraConfigureDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onOpenChange: PropTypes.func.isRequired,
  connectionId: PropTypes.string,
  ensureConnection: PropTypes.func,
  canEdit: PropTypes.bool,
  onConfigured: PropTypes.func,
};
